
























































import { Component, Vue } from 'vue-property-decorator'
import { getPermissionState, getToken, NotificationPermission } from '@/modules/firebase/messaging'


@Component
export default class Settings extends Vue {
    permissionState = getPermissionState()
    token: string|null = null

    async mounted() {
        if (this.isGranted) {
            this.token = await getToken()
        }
    }

    async enableNotifications() {
        this.token = await getToken()
        console.info('enableNotifications', this.token)
    }

    get isDefault() {
        return this.permissionState === NotificationPermission.DEFAULT
    }

    get isDenied() {
        return this.permissionState === NotificationPermission.DENIED
    }

    get isGranted() {
        return this.permissionState === NotificationPermission.GRANTED
    }
}
